<template>
  <div>
    <v-dialog v-model="contract_report" max-width="1200" persistent scrollable>
      <v-card :loading="loading">
        <v-card-title class="p-1">
          <v-col cols="12" style="font-size: 18px;padding:0px" class="text-center mt-1">
            <b style="color:#666666;">Construction Contract</b>
          </v-col>
        </v-card-title>
        <v-divider class></v-divider>
        <v-card-text class style="height: 100%;">
          <v-row dense class="custom-font-for-print mt-2">
            <v-col
              cols="12"
              class="grey-background d-flex d-print-none"
              style="font-size: 18px; text-align: center;"
            >
              <span style="width: 97.5%" class="d-flex justify-center">Title</span>
              <span style="width: 2.5%">
                <v-icon class="cursor-pointer" @click="openReportTextDialog(1,1)">mdi-border-color</v-icon>
              </span>
            </v-col>
            <v-col cols="12" v-html="getReportText(1,1)" class="ml-1"></v-col>

            <v-col
              cols="12"
              class="grey-background mt-1"
              style="font-size: 18px; text-align: center;"
            >Cover Page</v-col>
            <v-col cols="12" class="ml-1">
              <v-row dense style="margin-top: 8px;">
                <v-col cols="12">
                  AGREEMENT made as of the
                  <b>{{contract_dateof}}</b> day of the
                  <b>{{contract_month}}</b> in the year of
                  <b>{{contract_year}}</b>:
                </v-col>
              </v-row>
              <v-row dense style="margin-top: 8px;">
                <v-col cols="3" style="max-width: 19%; text-align: right;">BETWEEN the Owner :</v-col>
                <v-col
                  cols="5"
                  class
                  style="max-width: 36.2%;"
                  v-if="project_details && project_details.customer && project_details.customer.bill_to_company == true && project_details.bill_to"
                >
                  <b>
                    {{ project_details && project_details.bill_to ? project_details.bill_to :""}}
                    <br />
                    {{project_details ? project_details.bill_to_address_1 ? project_details.bill_to_address_1 : '': '' }}
                    {{ project_details ? project_details.bill_to_address_2 ? ', ' +project_details.bill_to_address_2 : '': ''}}
                    <br />
                    {{( project_details ? project_details.bill_to_city_details ? '' +project_details.bill_to_city_details.city_name:'' : '' )}}
                    {{( project_details ? project_details.bill_to_state_details ? ', ' +project_details.bill_to_state_details.state_name:'' : '' )}}
                    {{( project_details ? project_details.bill_to_zip ? '-' +project_details.bill_to_zip:'' : '' )}}
                  </b>
                </v-col>
                <v-col cols="5" class style="max-width: 36.2%;" v-else>
                  <b>
                    {{project_details ? project_details.customer ? project_details.customer.full_name:'':''}}
                    <br />
                    {{project_details ? project_details.customer ? project_details.customer.address_line_1 ? project_details.customer.address_line_1 : '': '' : ''}}
                    {{project_details ? project_details.customer ? project_details.customer.address_line_2 ? ', ' +project_details.customer.address_line_2 : '': '' : ''}}
                    <br />
                    {{(project_details ? project_details.customer ? project_details.customer.city_details ? ' ' +project_details.customer.city_details.city_name:'' : '' :'' )}}
                    {{(project_details ? project_details.customer ? project_details.customer.state_details ? ', ' +project_details.customer.state_details.state_name:'' : '' :'' )}}
                    {{(project_details ? project_details.customer ? project_details.customer.zip ? '-' +project_details.customer.zip:'' : '' :'' )}}
                  </b>
                </v-col>
              </v-row>
              <v-row dense style="margin-top: 8px;">
                <v-col cols="3" style="max-width: 19%; text-align: right;">and the Contractor :</v-col>
                <v-col cols="5" class style="max-width: 36.2%;">
                  <b>
                    {{company_details.name}}
                    <br />
                    {{company_details.shipping_address_line_1}}{{company_details.shipping_address_line_2 ? ', '+company_details.shipping_address_line_2 : ''}}
                    <br />
                    {{company_details.shipping_city_details ? company_details.shipping_city_details.city_name : '' }}{{company_details.shipping_state_details ? ', '+company_details.shipping_state_details.short_name : '' }}{{company_details.shipping_zip ? '-'+company_details.shipping_zip : '' }}
                  </b>
                </v-col>
              </v-row>

              <v-row dense style="margin-top: 8px;">
                <v-col
                  cols="3"
                  style="max-width: 19%;"
                  class="text-right"
                >for the following Project is :</v-col>
                <v-col cols="5" class style="max-width: 36.2%;">
                  <b>
                    {{project_details.p_name}}
                    <br />
                    {{project_details.p_address_1}}{{project_details.p_address_2 ? ', '+project_details.p_address_2 : ''}}
                    <br />
                    {{(project_details.city)?''+project_details.city.city_name:''}}{{(project_details.state)? ', ' +project_details.state.short_name :''}}{{project_details.p_zip ? '-'+project_details.p_zip : ''}}
                  </b>
                </v-col>
              </v-row>

              <v-row dense style="margin-top: 8px;">
                <v-col cols="3" style="max-width: 19%;" class="text-right">The Architect is :</v-col>
                <v-col cols="5" class style="max-width: 36.2%;">
                  <b>{{project_details.architect_name}}</b>
                </v-col>
              </v-row>

              <!-- <v-row dense style="margin-top: 8px;">
                <v-col cols="3" style="max-width: 19%;" class="text-right">The Architect is:</v-col>
                <v-col cols="5" class="d-print-none" style="max-width: 36.2%;">
                  <v-textarea
                    v-model="report_details.architect"
                    outlined
                    rows="3"
                    dense
                    hide-details
                    :readonly="!report_details.edit_architect"
                  ></v-textarea>
                </v-col>
                <v-col
                  cols="1"
                  v-if="!report_details.edit_architect"
                  class="d-print-none d-flex align-center"
                >
                  <v-btn
                    text
                    icon
                    @click="loading = true; report_details.edit_architect = true; loading = false;"
                  >
                    <v-icon>mdi-border-color</v-icon>
                  </v-btn>
                </v-col>

                <v-col
                  cols="1"
                  v-if="report_details.edit_architect"
                  class="d-print-none d-flex align-center"
                >
                  <v-btn text icon @click="saveArchitech();">
                    <v-icon>mdi-content-save</v-icon>
                  </v-btn>
                  <v-btn
                    text
                    icon
                    @click="loading = true; report_details.edit_architect = false; loading = false;"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-col>
              </v-row>-->
              <v-row dense style="margin-top: 8px;">
                <v-col cols="12">The Owner and Contractor agree as follows.</v-col>
              </v-row>
            </v-col>

            <v-col
              cols="12"
              class="grey-background mt-2 d-flex d-print-none"
              style="font-size: 18px; text-align: center;"
            >
              <span style="width: 97.5%" class="d-flex justify-center">Table of Articles</span>
              <span style="width: 2.5%">
                <v-icon class="cursor-pointer" @click="openReportTextDialog(1,2)">mdi-border-color</v-icon>
              </span>
            </v-col>
            <v-col v-html="getReportText(1,2)" class="margin-left: 4px;"></v-col>

            <v-col
              cols="12"
              class="grey-background mt-2 d-flex d-print-none"
              style="font-size: 18px; text-align: center;"
            >
              <span
                style="width: 97.5%"
                class="d-flex justify-center"
              >Article 1 THE CONTRACT DOCUMENTS</span>
              <span v-if="!printing_report" style="width: 2.5%">
                <v-icon class="cursor-pointer" @click="openReportTextDialog(1,3)">mdi-border-color</v-icon>
              </span>
            </v-col>
            <v-col cols="12" v-html="getReportText(1,3)" class="ml-1"></v-col>

            <v-col
              cols="12"
              class="grey-background mt-2 d-flex d-print-none"
              style="font-size: 18px; text-align: center;"
            >
              <span
                style="width: 97.5%"
                class="d-flex justify-center"
              >ARTICLE 2 THE WORKS OF THIS CONTRACT</span>
              <span style="width: 2.5%">
                <v-icon class="cursor-pointer" @click="openReportTextDialog(1,4)">mdi-border-color</v-icon>
              </span>
            </v-col>
            <v-col cols="12" v-html="getReportText(1,4)" class="ml-1"></v-col>

            <v-col
              cols="12"
              class="grey-background mt-2 d-flex d-print-none"
              style="font-size: 18px; text-align: center;"
            >
              <span
                style="width: 97.5%"
                class="d-flex justify-center"
              >ARTICLE 3 DATE OF COMMENCEMENT AND SUBSTANTIAL COMPLETION</span>
              <!-- <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                  <v-icon
                  v-bind="attrs" v-on="on"
                  class="cursor-pointer"
                  @click="change_month_dialog=true;"
                   v-if="next_change_order_id<1"
                  >mdi-clipboard-edit-outline</v-icon>
                  </template>
                  <span>Project Time</span>
              </v-tooltip>-->
              <span style="width: 2.5%">
                <v-icon class="cursor-pointer" @click="openReportTextDialog(1,5)">mdi-border-color</v-icon>
              </span>
            </v-col>
            <v-col cols="12" v-html="getReportText(1,5)" class="ml-1"></v-col>

            <v-col
              cols="12"
              class="grey-background mt-2 d-flex d-print-none"
              style="font-size: 18px; text-align: center;"
            >
              <span style="width: 97.5%" class="d-flex justify-center">ARTICLE 4 CONTRACT SUM</span>
              <span style="width: 2.5%">
                <v-icon class="cursor-pointer" @click="openReportTextDialog(1,14)">mdi-border-color</v-icon>
              </span>
            </v-col>
            <v-col cols="12" v-html="getReportText(1,14)" class="ml-1"></v-col>
            <v-col
              cols="12"
              class="grey-background mt-2 d-flex d-print-none"
              style="font-size: 18px; text-align: center;"
            >
              <span style="width: 97.5%" class="d-flex justify-center">ARTICLE 5 PAYMENTS</span>
              <span style="width: 2.5%">
                <v-icon class="cursor-pointer" @click="openReportTextDialog(1,6)">mdi-border-color</v-icon>
              </span>
            </v-col>
            <v-col cols="12" v-html="getReportText(1,6)" class="ml-1"></v-col>

            <v-col
              cols="12"
              class="grey-background mt-2 d-flex d-print-none"
              style="font-size: 18px; text-align: center;"
            >
              <span style="width: 97.5%" class="d-flex justify-center">5.2 FINAL PAYMENT</span>
              <span style="width: 2.5%">
                <v-icon class="cursor-pointer" @click="openReportTextDialog(1,7)">mdi-border-color</v-icon>
              </span>
            </v-col>
            <v-col cols="12" v-html="getReportText(1,7)" class="ml-1"></v-col>

            <v-col
              cols="12"
              class="grey-background mt-2 d-flex d-print-none"
              style="font-size: 18px; text-align: center;"
            >
              <span style="width: 97.5%" class="d-flex justify-center">ARTICLE 6 DISPUTE RESOLUTION</span>
              <span style="width: 2.5%">
                <v-icon class="cursor-pointer" @click="openReportTextDialog(1,8)">mdi-border-color</v-icon>
              </span>
            </v-col>
            <v-col cols="12" v-html="getReportText(1,8)" class="ml-1"></v-col>

            <v-col
              cols="12"
              class="grey-background mt-2 d-flex d-print-none"
              style="font-size: 18px; text-align: center;"
            >
              <span
                style="width: 97.5%"
                class="d-flex justify-center"
              >§ 6.2 BINDING DISPUTE RESOLUTION</span>
              <span style="width: 2.5%">
                <v-icon class="cursor-pointer" @click="openReportTextDialog(1,9)">mdi-border-color</v-icon>
              </span>
            </v-col>
            <v-col cols="12" v-html="getReportText(1,9)" class="ml-1"></v-col>

            <v-col
              cols="12"
              class="grey-background mt-2 d-flex d-print-none"
              style="font-size: 18px; text-align: center;"
            >
              <span
                style="width: 97.5%"
                class="d-flex justify-center"
              >ARTICLE 7 TERMINATION OR SUSPENSION</span>
              <span style="width: 2.5%">
                <v-icon class="cursor-pointer" @click="openReportTextDialog(1,10)">mdi-border-color</v-icon>
              </span>
            </v-col>
            <v-col cols="12" v-html="getReportText(1,10)" class="ml-1"></v-col>
            <v-col
              cols="12"
              class="grey-background mt-2 d-flex d-print-none"
              style="font-size: 18px; text-align: center;"
            >
              <span
                style="width: 97.5%"
                class="d-flex justify-center"
              >ARTICLE 8 MISCELLANEOUS PROVISIONS</span>
              <span style="width: 2.5%">
                <v-icon class="cursor-pointer" @click="openReportTextDialog(1,11)">mdi-border-color</v-icon>
              </span>
            </v-col>
            <v-col cols="12" v-html="getReportText(1,11)" class="ml-1"></v-col>

            <v-col
              cols="12"
              class="grey-background mt-2 d-flex d-print-none"
              style="font-size: 18px; text-align: center;"
            >
              <span
                style="width: 97.5%"
                class="d-flex justify-center"
              >ARTICLE 9 ENUMERATION OF CONTRACT DOCUMENTS</span>
              <span style="width: 2.5%">
                <v-icon class="cursor-pointer" @click="openReportTextDialog(1,12)">mdi-border-color</v-icon>
              </span>
            </v-col>
            <v-col cols="12" v-html="getReportText(1,12)" class="ml-1"></v-col>

            <v-col
              cols="12"
              class="grey-background mt-2 d-flex d-print-none"
              style="font-size: 18px; text-align: center;"
            >
              <span
                style="width: 97.5%"
                class="d-flex justify-center"
              >ARTICLE 10 INSURANCE AND BONDS</span>
              <span style="width: 2.5%">
                <v-icon class="cursor-pointer" @click="openReportTextDialog(1,13)">mdi-border-color</v-icon>
              </span>
            </v-col>
            <v-col cols="12" v-html="getReportText(1,13)" class="ml-1"></v-col>

            <v-col
              cols="12"
              class="grey-background mt-1"
              style="font-size: 18px; text-align: center;"
            >SIGNATURE</v-col>
            <v-col cols="12">
              <v-row dense class="ml-1">
                <v-col
                  cols="12"
                  class="mt-1"
                  style="text-align: center;"
                >This Agreement is entered into as of the day and year first written above</v-col>
                <v-col cols="3">
                  <v-divider style="margin-top: 45px;"></v-divider>OWNER (Signature)
                  <br />
                  {{project_details ? project_details.customer ? project_details.customer.full_name:'':''}}
                </v-col>
                <v-col cols="6"></v-col>
                <v-col cols="3">
                  <v-divider style="margin-top: 45px;"></v-divider>CONTRACTOR (Signature)
                  <br />
                  {{company_details.name}} ({{company_details.license_number}})
                  <br />
                  {{company_details.contact_person}} (President)
                  <br />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider class></v-divider>
        <v-card-actions>
          <v-btn color="error" @click="closePopup()" :disabled="loading">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            :loading="loading"
            @click="generateReport('whole_page',true); is_send_report = false;"
            color="primary"
            class="pr-3 text-capitalize"
          >
            <v-icon left>mdi-printer</v-icon>Print
          </v-btn>
          <v-btn
            :loading="loading"
            @click="generateReport(false); is_send_report = false; preview_pdf_dialog = true;"
            color="primary"
            class="pr-3 text-capitalize"
          >
            <v-icon left>mdi-content-save-outline</v-icon>Sign Online
          </v-btn>
          <v-btn
            @click="preview_pdf_dialog = true; is_send_report = true; generateReport(false);"
            color="primary"
            class="pr-3 text-capitalize"
          >
            <v-icon left>mdi-send</v-icon>Send for Signature
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="preview_pdf_dialog" max-width="800" persistent>
      <v-card :loading="preview_pdf_loading">
        <v-card-text>
          <v-row dense>
            <v-col cols="12">
              <iframe :src="preview_page_link" frameborder="0" style="width:100%;height:800px"></iframe>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="error"
            @click="preview_pdf_dialog = false; user_sign_blob = []; customer_sign_blob = ''; active_page = 0;"
          >Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="text-capitalize"
            @click="is_send_report ? email_dialog = true : signature_dialog = true"
            v-if="total_page == active_page"
            :loading="preview_pdf_loading"
          >Finish</v-btn>
          <v-btn
            v-else
            color="primary"
            class="text-capitalize"
            @click="is_send_report ? generateReport(false) : signature_dialog = true;"
            :loading="preview_pdf_loading"
          >Next Page</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="report_text_dialog" max-width="900" persistent>
      <v-card :loading="report_text_loading">
        <v-card-title class="headline">Update Text</v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col cols="12">
              <vue-editor v-model="report_text_data.text" :editor-toolbar="customToolbar" />
            </v-col>
            <v-col cols="12">
              <v-row
                dense
                class="report-header2"
                v-if="report_text_data.report == '1' && report_text_data.section  == '14'"
              >
                <v-col cols="12">
                  <b>Below are short code for dynamic value:</b>
                </v-col>
                <v-col cols="12">{amount}</v-col>
                <v-col cols="12">{amount_in_word}</v-col>
              </v-row>
              <v-row
                dense
                class="report-header2"
                v-if="report_text_data.report == '2' && report_text_data.section  == '1'"
              >
                <v-col cols="12">
                  <b>Below are short code for dynamic value:</b>
                </v-col>
                <v-col cols="12">{amount_in_word}</v-col>
                <v-col cols="12">{project_details}</v-col>
              </v-row>
              <v-row
                dense
                class="report-header2"
                v-if="report_text_data.report == '3' && report_text_data.section  == '1'"
              >
                <v-col cols="12">
                  <b>Below are short code for dynamic value:</b>
                </v-col>
                <v-col cols="12">{balance}</v-col>
                <v-col cols="12">{project_name}</v-col>
                <v-col cols="12">{customer_address}</v-col>
              </v-row>
              <v-row
                dense
                class="report-header2"
                v-if="report_text_data.report == '1' && report_text_data.section  == '5'"
              >
                <v-col cols="12">
                  <b>Below are short code for dynamic value:</b>
                </v-col>
                <!-- <v-col cols="12">{start_time}</v-col>
                <v-col cols="12">{end_time}</v-col>
                <v-col cols="12">{contract_time_type}</v-col>-->
                <v-col cols="12">{total_order_days}</v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="report_text_dialog = false">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="text-capitalize"
            @click="updateReportText('no')"
          >Update for this project</v-btn>
          <v-btn
            color="primary"
            class="text-capitalize"
            @click="updateReportText('yes')"
          >Update Template</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="change_month_dialog" persistent max-width="400px">
      <v-card>
        <v-card-title>
          <span>Project Completion Time</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row dense>
              <v-col cols="12" class="d-flex">
                <v-col cols="3">
                  <v-text-field
                    single-line
                    dense
                    hide-details
                    v-model="start_time"
                    type="number"
                    style="margin-top: -5px"
                  ></v-text-field>
                </v-col>
                <v-col cols="2" class="text-center">
                  <b>To</b>
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    single-line
                    dense
                    hide-details
                    v-model="end_time"
                    :error-messages="form_error.end_time"
                    type="number"
                    style="margin-top: -5px"
                  ></v-text-field>
                </v-col>
                <v-col cols="5">
                  <v-select
                    :items="contract_time_type_list"
                    v-model="contract_time_type"
                    hide-details
                    dense
                    style="margin-top: -5px"
                  ></v-select>
                </v-col>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="change_month_dialog = false;">Close</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="changeMonth()" v-if="this.start_time<this.end_time">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <SendMailDialog
      :email_id="email_ids"
      :email_dialog="email_dialog"
      @closeDialog="closeSendMailDialog"
      @sendMail="sendMail"
    />
    <Signatura
      :customer_sign="customer_sign_blob"
      :active_page="active_page"
      @updateValue="updateParent"
      @clearValue="clearParent"
      :project_details="project_details"
      :signature_dialog="signature_dialog"
    />
  </div>
</template>
 <script>
import { VueEditor } from "vue2-editor";
import { getCompanyDetails, getAmountInWord } from "../../plugins/helper";
import Signatura from "../projects/Signatura";
import SendMailDialog from "../projects/SendMailDialog";
import axios from "../../plugins/axios";
import { mapMutations } from "vuex";
const moment = require("moment");
export default {
  data() {
    return {
      customToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ["bold", "italic", "underline", "strike"], // toggled buttons
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" }
        ],
        //["blockquote", "code-block"],
        [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
        [{ indent: "-1" }, { indent: "+1" }],
        [{ color: [] }, { background: [] }],
        ["link", "image", "video"],
        //["clean"],
        // This is what I have added
        [{ size: ["small", false, "large"] }]
      ],
      report_text_dialog: false,
      report_text_loading: false,
      report_text_data: {},
      report_texts: [],
      project_report_texts: [],
      preview_pdf_loading: "",
      total_page: "",
      active_page: 0,
      user_sign_blob: [],
      customer_sign_blob: "",
      signature_dialog: false,
      loading: false,
      is_send_report: false,
      email_ids: null,
      email_id_arr: [],
      email_ids_error: null,
      email_dialog: false,
      send_pdf_loading: false,
      items: [],
      company_details: getCompanyDetails(),
      preview_pdf_dialog: false,
      preview_page_link: "",
      total_amt: "",
      total_order_days: "",
      project_data_flag: "",
      invoice_no: "0",
      contract_date: "",
      change_month_dialog: false,
      start_time: 3,
      end_time: 6,
      contract_time_type: "months",
      printing_report: false,
      form_error: {},
      // month_list:[1,2,3,4,5,6,7,8,9,10,11,12],
      contract_time_type_list: [
        {
          text: "Day",
          value: "days"
        },
        {
          text: "Month",
          value: "months"
        },
        {
          text: "Year",
          value: "years"
        }
      ],
      next_change_order_id: 0
    };
  },
  props: [
    "contract_report",
    "project_details",
    "is_preview_only",
    "generate_invoice_project",
    "report_header_name"
  ],
  watch: {
    contract_report: function(value) {
      if (value) {
        this.getData();
      }
    },
    generate_invoice_project: function(value) {
      if (value) {
        this.getData();
      }
    }
  },
  computed: {
    amount_in_word() {
      return getAmountInWord(this.total_amt);
    },
    user_name() {
      return localStorage.getItem("user_name");
    },
    contract_dateof() {
      return moment(this.contract_date).format("DD");
    },
    contract_month() {
      return moment(this.contract_date).format("MMMM");
    },
    contract_year() {
      return moment(this.contract_date).format("YYYY");
    }
  },
  components: {
    Signatura,
    SendMailDialog,
    VueEditor
  },
  methods: {
    ...mapMutations("utils", ["setAlert"]),
    getData() {
      if (this.project_details.project_work == "remodeling") {
        this.project_data_flag = 2;
      } else if (this.project_details.project_work == "new_construction") {
        this.project_data_flag = 1;
      } else if (this.project_details.project_work == "project_management") {
        this.project_data_flag = 4;
      }
      this.preview_page_link = "";
      this.active_page = 0;
      this.user_sign_blob = [];
      this.customer_sign_blob = "";
      this.next_change_order_id = this.project_details.p_lock
        ? this.project_details.last_change_order + parseFloat(1)
        : this.project_details.last_change_order;
      console.log("next_change_order_id", this.next_change_order_id);

      this.getTotalPage();
      this.getReportTexts();
      this.getAllInvoiceData();
    },
    updateReportText(update_for_all_project) {
      this.report_text_data.project_id = this.project_details.project_id;
      this.report_text_data.update_for_all_project = update_for_all_project;
      this.report_text_loading = true;
      let _self = this;
      axios
        .post("update_project_report_text", this.report_text_data)
        .then(function() {
          _self.report_text_dialog = false;
          _self.getReportTexts();
          _self.report_text_loading = false;
        })
        .catch(function() {
          _self.report_text_loading = false;
        });
    },
    sendMail(variable) {
      this.email_id_arr = variable;
      this.sendSalesInvoiceReport();
    },
    changeMonth() {
      let company_data = localStorage.getItem("company_data");
      company_data = JSON.parse(company_data);
      var formData = new FormData();
      formData.append("project_id", this.project_details.project_id);
      formData.append("user_name", localStorage.getItem("user_id"));
      formData.append("company_id", company_data.company_id);
      formData.append("report_name", "contract");
      formData.append("report_header_name", this.report_header_name);
      formData.append("start_time", this.start_time);
      formData.append("end_time", this.end_time);
      formData.append("contract_time_type", this.contract_time_type);
      formData.append("total_order_days", this.total_order_days);
      this.loading = true;
      axios
        .post("save_temp_report_data", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(response => {
          if (!response.data.status) {
            for (let key in response.data.errors) {
              this.form_error[key] = response.data.errors[key][0];
              console.log(this.form_error[key]);
              console.log("data.errors", key, response.data.errors);
            }
          }
          if (response.data.status) {
            this.change_month_dialog = false;
            this.form_error = {};
          }
          this.loading = false;
        })
        .catch(function(error) {
          console.log(error);
          this.loading = false;
        });
    },
    closeSendMailDialog() {
      this.email_dialog = false;
      this.preview_pdf_dialog = false;
      this.user_sign_blob = [];
      this.customer_sign_blob = "";
      this.active_page = 0;
    },
    updateParent(variable) {
      if (variable.user_sign_blob) {
        this.user_sign_blob.push({
          page: this.active_page,
          sign_blob: variable.user_sign_blob
        });
      }
      if (variable.customer_sign_blob && this.active_page == 1) {
        this.customer_sign_blob = variable.customer_sign_blob;
      }
      this.signature_dialog = false;
      if (this.is_send_report) {
        if (this.total_page == this.active_page) {
          this.email_dialog = true;
          this.email_ids =
            this.project_details.customer.email +
            "@" +
            this.project_details.customer.email_domain.domain;
        } else {
          this.generateReport(false);
        }
      } else {
        if (this.total_page == this.active_page) {
          this.generateReport(true);
        } else {
          this.generateReport(false);
        }
      }
    },
    clearParent(variable) {
      console.log(variable);
      this.signature_dialog = false;
    },
    closePopup() {
      this.$emit("updateValue");
    },
    getTotalPage() {
      let company_data = localStorage.getItem("company_data");
      company_data = JSON.parse(company_data);
      var formData = new FormData();
      formData.append("project_id", this.project_details.project_id);
      formData.append("user_name", localStorage.getItem("user_id"));
      formData.append("company_id", company_data.company_id);
      formData.append("generate_pdf_flag", "get_total");
      formData.append("project_data_flag", this.project_data_flag);
      formData.append("report_name", "contract");
      formData.append("report_header_name", this.report_header_name);
      formData.append("start_time", this.start_time);
      formData.append("end_time", this.end_time);
      formData.append("contract_time_type", this.contract_time_type);
      formData.append("total_order_days", this.total_order_days);
      this.loading = true;
      axios
        .post("generate_report_pdf", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(response => {
          if (response.data.status) {
            this.total_page = response.data.total_page;
          }
          this.loading = false;
        })
        .catch(function(error) {
          console.log(error);
          this.loading = false;
        });
    },
    generateReport(is_past_page, direct_print = false) {
      this.preview_pdf_loading = true;
      this.active_page++;
      let company_data = localStorage.getItem("company_data");
      company_data = JSON.parse(company_data);
      // let url = 'flag=save&project_id='+this.project_details.project_id+'&user_name='+localStorage.getItem('user_id')+'&company_id='+company_data.company_id+'&sign='+this.sign_blob;
      var formData = new FormData();

      if (is_past_page) {
        if (this.user_sign_blob) {
          for (let key in this.user_sign_blob) {
            formData.append(
              `user_sign_blob[${this.user_sign_blob[key].page}]`,
              this.user_sign_blob[key].sign_blob
            );
          }
        }
        if (this.customer_sign_blob) {
          formData.append(`customer_sign_blob`, this.customer_sign_blob);
        }
        formData.append("generate_pdf_flag", "whole_page");
      } else {
        formData.append("generate_pdf_flag", "single_page");
      }
      formData.append("flag", "save");
      formData.append("project_id", this.project_details.project_id);
      formData.append("user_name", localStorage.getItem("user_id"));
      formData.append("company_id", company_data.company_id);
      formData.append("total_page", this.total_page);
      formData.append("active_page", this.active_page);
      formData.append("project_data_flag", this.project_data_flag);
      formData.append("report_name", "contract");
      formData.append("report_header_name", this.report_header_name);
      formData.append("direct_print", direct_print);
      formData.append("start_time", this.start_time);
      formData.append("end_time", this.end_time);
      formData.append("contract_time_type", this.contract_time_type);
      formData.append("total_order_days", this.total_order_days);

      axios
        .post("generate_report_pdf", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(response => {
          if (is_past_page) {
            if (response.data.status) {
              if (direct_print) {
                var File_url = response.data.file_url;
                window.open(File_url, "Download");
              } else {
                this.setAlert({
                  show: true,
                  variant: "primary",
                  message: response.data.message,
                  dismissCountDown: 0
                });
                this.closePopup();
              }
              this.preview_pdf_dialog = false;
            }
          } else {
            this.preview_page_link = response.data.preview_page_link;
          }
          this.preview_pdf_loading = false;
        })
        .catch(function(error) {
          console.log(error);
          this.preview_pdf_loading = false;
        });
    },
    sendSalesInvoiceReport() {
      let company_data = localStorage.getItem("company_data");
      company_data = JSON.parse(company_data);
      let data = {
        flag: "mail",
        project_id: this.project_details.project_id,
        user_name: localStorage.getItem("user_id"),
        company_id: company_data.company_id,
        active_page: this.active_page,
        total_page: this.total_page,
        email_id_arr: this.email_id_arr,
        email_ids: this.email_ids,
        generate_pdf_flag: "whole_page",
        project_data_flag: this.project_data_flag,
        report_name: "contract",
        start_time: this.start_time,
        end_time: this.end_time,
        contract_time_type: this.contract_time_type
      };
      if (this.user_sign_blob) {
        data.user_sign_blob = this.user_sign_blob;
      }
      if (this.customer_sign_blob) {
        data.customer_sign_blob = this.customer_sign_blob;
      }

      this.send_pdf_loading = true;
      axios
        .post("generate_report_pdf", data)
        .then(response => {
          this.email_ids_error = null;
          if (response.data.status) {
            this.email_dialog = false;
            this.setAlert({
              show: true,
              variant: "primary",
              message: response.data.message,
              dismissCountDown: 0
            });
            this.preview_pdf_dialog = false;
            this.closePopup();
          } else {
            this.email_ids_error = response.data.errors["email_ids"];
          }
          this.send_pdf_loading = false;
        })
        .catch(function(error) {
          console.log(error);
          this.send_pdf_loading = false;
        });
    },
    getReportDetails() {
      let _self = this;
      this.loading = true;
      axios
        .get(
          "get_item_group?project_id=" +
            this.project_details.project_id +
            "&project_data_flag=" +
            this.project_data_flag
        )
        .then(response => {
          let response_data = response.data;
          _self.items = response_data.data;
          _self.total_amt = response_data.total_amt;
          _self.total_order_days = response_data.total_order_days;
          _self.loading = false;
        })
        .catch(function(error) {
          console.log(error);
          _self.loading = false;
        });
    },
    openReportTextDialog(report, section) {
      this.report_text_data.text = this.getReportText(report, section, true);
      this.report_text_data.report = report;
      this.report_text_data.section = section;
      this.report_text_dialog = true;
    },
    getReportText(report, section, is_edit_mode) {
      let report_text = "";
      this.project_report_texts.filter(item => {
        if (item.report == report && item.section == section) {
          report_text = item.text;
        }
      });
      if (!report_text) {
        this.report_texts.filter(item => {
          if (item.report == report && item.section == section) {
            report_text = item.text;
          }
        });
      }

      if (report == "1" && section == "14" && !is_edit_mode) {
        let totalScheduleValue = "$" + this.total_amt;
        let amountInWord = "US$ " + this.amount_in_word;
        report_text = report_text.replace("{amount}", totalScheduleValue);
        report_text = report_text.replace("{amount_in_word}", amountInWord);
      }
      if (report == "2" && section == "1" && !is_edit_mode) {
        let amountInWord = "US$ " + this.amount_in_word;
        report_text = report_text.replace("{amount_in_word}", amountInWord);
        let address =
          "<b>" +
          this.project_details.p_address_1 +
          ", " +
          this.project_details.p_address_2
            ? this.project_details.p_address_2
            : "" +
              ", " +
              (this.project_details.city
                ? this.project_details.city.city_name
                : "") +
              ", " +
              (this.project_details.state
                ? this.project_details.state.state_name
                : "") +
              " - " +
              this.project_details.p_zip +
              "</b>";
        report_text = report_text.replace("{project_details}", address);
      }
      if (report == "3" && section == "1" && !is_edit_mode) {
        let balance = "$" + this.total_amt;
        report_text = report_text.replace("{balance}", balance);
        report_text = report_text.replace(
          "{project_name}",
          this.project_details.p_name
        );
        report_text = report_text.replace(
          "{customer_address}",
          this.project_details.customer.address_line_1 +
            ", " +
            this.project_details.customer.address_line_2 +
            ", " +
            (this.project_details.customer.city_details
              ? this.project_details.customer.city_details.city_name
              : "") +
            ", " +
            (this.project_details.customer.state_details
              ? this.project_details.customer.state_details.state_name
              : "") +
            " - " +
            this.project_details.customer.zip
        );
      }
      if (report == "1" && section == "5" && !is_edit_mode) {
        report_text = report_text.replace("{start_time}", this.start_time);
        report_text = report_text.replace("{end_time}", this.end_time);
        report_text = report_text.replace(
          "{contract_time_type}",
          this.contract_time_type
        );
        report_text = report_text.replace(
          "{total_order_days}",
          this.total_order_days
        );
      }
      return report_text;
    },
    getAllInvoiceData() {
      let _self = this;
      let invoice_no = _self.invoice_no;
      _self.loading = true;
      axios
        .get(
          "get_all_invoice_detail?project_id=" +
            this.project_details.project_id +
            "&project_data_flag=" +
            this.project_data_flag +
            "&generate_invoice_id=" +
            invoice_no
        )
        .then(response => {
          let response_data = response.data;
          _self.items = response_data.data;
          _self.total_amt = response_data.original_contract_sum;
          _self.contract_date = response_data.contract_date;
          _self.start_time = response_data.contract_start_time;
          _self.end_time = response_data.contract_end_time;
          _self.contract_time_type = response_data.contract_time_type;
          _self.total_order_days = response_data.total_order_days;
          _self.loading = false;
        })
        .catch(function(error) {
          console.log(error);
          _self.loading = false;
        });
    },
    getReportTexts() {
      let _self = this;
      this.loading = true;
      axios
        .get("get_report_texts?project_id=" + this.project_details.project_id)
        .then(function(res) {
          _self.project_report_texts = res.data.project_report_texts;
          _self.report_texts = res.data.data;
          _self.loading = false;
        })
        .then(function() {
          _self.loading = false;
        });
    }
  },
  created: function() {},
  mounted: function() {
    // this.$refs.userSignaturePad.openSignaturePad();
    // this.$refs.customerSignaturePad.openSignaturePad();
  }
};
</script>
 <style scoped>
.right-border-grey > td {
  border-right: thin solid rgba(0, 0, 0, 0.12);
}
.right-border-white > td {
  border-right: thin solid white;
}
ul li {
  list-style-type: none;
  &:before {
    content: "• ";
    margin-left: -1em;
  }
}
</style>
 